/**
 * Utility function to handle axios errors consistently
 * @param {Error} error - The error object from axios
 * @param {string} context - Context for the error (e.g., "consultar ticket", "processar pagamento")
 * @returns {Object} - Standardized error object
 */
export const handleApiError = (error, context = "operação") => {
  // Handle timeout errors
  if (error.code === 'ECONNABORTED') {
    return { message: "Tempo esgotado, tente novamente" };
  }
  
  // Handle network errors
  if (error.message === 'Network Error') {
    return { message: "Erro de conexão. Verifique sua internet e tente novamente" };
  }
  
  // Handle response errors
  if (error.response && error.response.data) {
    return error.response.data;
  }
  
  // Handle axios errors with message
  if (error.message) {
    return { message: error.message };
  }
  
  // Fallback for unknown errors
  return { message: `Erro desconhecido ao ${context}` };
};

/**
 * Wrapper for axios catch blocks to standardize error handling
 * @param {Function} axiosCall - The axios call to wrap
 * @param {string} context - Context for error messages
 * @returns {Promise} - Promise that resolves with data or rejects with standardized error
 */
export const withErrorHandling = (axiosCall, context) => {
  return axiosCall.catch((error) => {
    throw handleApiError(error, context);
  });
}; 